export default "__VITE_ASSET__CLN0AC57__"